import React from 'react';
import { Field } from 'redux-form';
import { map } from 'lodash';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';
import CheckboxFieldPanel from 'shared-components/reduxForms/utilities/CheckboxFieldPanel';

const SocialEventPolicyCheckbox = ({ socialEventsPolicyCopy = [], intl }) => {
  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';
  return (
    <div>
      <div className="flex middle h5">
        <img
          className="icon margin-md-right"
          src="/web-2/assets/images/rules.svg?v=rb"
          alt={ intl.formatMessage({ id: 'inbox_review_offer.social_event_policy_checkbox.rules_icon', defaultMessage: 'Rules Icon' }) }
        />
        <span>
          <FormattedMessage
            id='inbox_review_offer.social_event_policy_checkbox.social_policy'
            defaultMessage='Social Event Policy'
          />
        </span>
      </div>
      <p className="text-gray-600">
        <FormattedMessage
          id='inbox_review_offer.social_event_policy_checkbox.must_review'
          defaultMessage='You must review and accept the {agreement}.'
          values={{
            agreement: 
              <a className="btn-link-primary underline heavier" href={`${urlPrefix}/legal/terms`} target="_blank">
                <FormattedMessage id='inbox_review_offer.social_event_policy_checkbox.peerspace_agreement' defaultMessage='Peerspace Services Agreement' />
              </a>
          }}
        />
      </p>
      <ul className="social-event-policy rounded-border panel flex column">
        { map(socialEventsPolicyCopy, (line) => {
          return (
            <li>{line}</li>
          );
        })}
      </ul>
      <div className="flex margin-lg-top checkbox-field-panel">
        <Field
          id="accept-social-event-policy"
          name="guest_social_events_policy_accepted"
          attributes={{ 'data-testing-id': 'social-event-policy-checkbox' }}
          component={CheckboxFieldPanel}
          label={
            <FormattedMessage
              id='inbox_review_offer.social_event_policy_checkbox.accept_policy'
              defaultMessage='I agree to the {agreement}, and acknowledge that I am liable for any incidents or damages resulting from the actions of any attendees. I understand my booking may be cancelled if I do not provide proof of insurance upon request.'
              values={{
                agreement: <a className="btn-link-primary underline heavier" href={`${urlPrefix}/legal/terms`} target="_blank">
                  <FormattedMessage id='inbox_review_offer.social_event_policy_checkbox.peerspace_agreement' defaultMessage='Peerspace Services Agreement' />
                </a>
              }}
            />
          }
          option={true}
        />
      </div>
      <hr className="large-hr-margin" />
    </div>
  );
};

export default injectIntl(SocialEventPolicyCheckbox);
